var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"taiwan-list"},_vm._l((_vm.$store.state.taiwan),function(i,index){return _c('li',{key:index},[_c('a',{attrs:{"href":'http://' + i.url + '.100ec.cn/',"target":"_blank"}},[_vm._v(" "+_vm._s(i.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }